import React from 'react';
import classnames from 'classnames';
import numeral from 'numeral';
import {ResourcesMatching, HasErrors} from 'requests/components';

const FILE_NAME_PATTERN = /^[A-Za-z0-9\-_@]+\.(png|svg|jpg|jpeg)$/;
const FILE_TYPE_PATTERN = /^.+\.(png|svg|jpg|jpeg)$/;

const formatFilesize = (filesize) => {
  return `${numeral(filesize / 1000 / 1000).format('0.0')} MB`;
}

export default {
  getInitialState() {
    return {
      name: (this.props.workingSetImage) ? this.props.workingSetImage.name : "",
      nameIsInvalid: false,
      uploading: false,
      imageUrl: null,
      filesizeExceededBy: null,
      bucketPolicyFailed: false,
      fileTypeNotSupported: false,
    };
  },

  isUpdating() {
    return !!this.props.workingSetImage;
  },

  directToCloudDropzoneProps() {
    return {
      onDropzoneInit: this.handleDropzoneInit,
      onFileAdded: this.handleFileAdded,
      onFileRemoved: this.handleFileRemoved,
      onTemporaryDestinationCreated: this.handleTemporaryDestinationCreated,
      onBucketPolicyFailure: this.handleBucketPolicyFailure,
      onFilesizeTooLarge: this.handleFilesizeTooLarge,
    };
  },

  extensionLooksWrong() {
    let isWrong = false;

    const {name, dropzone} = this.state;
    const dropzoneFile = ((dropzone || {files: []}).files.length > 0) ? this.state.dropzone.files[0].name : "";
    const extension = (str) => str.split(".").pop();

    if (dropzoneFile && name) {
      if (extension(dropzoneFile) !== extension(name)) {
        isWrong = true;
      }
    }

    return isWrong;
  },

  extensionNotSupported() {
    const {name} = this.state;

    return ~name.indexOf('.') && name.split('.').pop().length > 1 && this.state.fileTypeNotSupported;
  },

  handleDropzoneInit(dropzone) {
    this.setState({
      dropzone,
    });
  },

  handleTemporaryDestinationCreated(imageUrl) {
    this.setState({
      imageUrl,
    });
  },

  handleFileAdded(filename) {
    let nextState = {
      filesizeExceededBy: null,
    };

    const nextFilename = filename.toLowerCase();

    if (!this.isUpdating()) {
      nextState.name = nextFilename;
      nextState.nameIsInvalid = !nextFilename.match(FILE_NAME_PATTERN);
      nextState.fileTypeNotSupported = !nextFilename.match(FILE_TYPE_PATTERN);
    }

    this.setState(nextState);
  },

  handleFileRemoved() {
    this.setState({imageUrl: null});
  },

  handleNameChanged(event) {
    const name = this._name.value;

    this.setState({
      name,
      nameIsInvalid: name.length > 0 && !name.match(FILE_NAME_PATTERN),
      fileTypeNotSupported: !name.match(FILE_TYPE_PATTERN)
    });
  },

  handleFilesizeTooLarge(actualSize, maximumSize) {
    this.setState({
      filesizeExceededBy: {
        actualSize,
        maximumSize,
      }
    });
  },

  handleBucketPolicyFailure() {
    this.setState({
      bucketPolicyFailed: true,
    });
  },

  nameFormGroup(request) {
    const rm = this.resourceManager();
    const {dropzone} = this.state;
    const nameFormGroupClassName = classnames(
      'form-group row string required',
      {'has-danger': this.state.filesizeExceededBy || this.extensionNotSupported() || this.state.nameIsInvalid || rm.requests.errorsFor(request).get('name')}
    );
    const fileTooLargeElement = (this.state.filesizeExceededBy) ?
      <div className="text-help">{formatFilesize(this.state.filesizeExceededBy.actualSize)} is too large (maximum of {formatFilesize(this.state.filesizeExceededBy.maximumSize)})</div> :
      null;
    const bucketPolicyFailedElement = (this.state.bucketPolicyFailed) ?
      <div className="text-help">Woops! We had a problem preparing the upload. Try again.</div> :
      null;
    const extensionLooksWrongElement = (this.extensionLooksWrong()) ?
      <div className="text-help">Hmm. You might double-check that file extension. They don&apos;t match.</div> :
      null;
    const fileTypeNotSupportedElement = (this.extensionNotSupported()) ?
      <div className="text-help">That file type is not supported right now.</div> :
      null;
    const maximumSizeInMB = (dropzone) ? dropzone.options.maxFilesize : "";

    return (
      <ResourcesMatching manager={rm}>
        <div className={nameFormGroupClassName}>
          <label className="string required col-xs-3 form-control-label p-xs-r-sm">Image Name
            <span title="Required">*</span>
          </label>
          <div className="col-xs-9">
            <input ref={(c) => {this._name = c;}} type="text" value={this.state.name} onChange={this.handleNameChanged} className="string required form-control" required={true} />
            <HasErrors request={request} errorKey="name">
              <div className="text-help">{rm.requests.errorsFor(request).get('name')}</div>
            </HasErrors>
            {fileTooLargeElement}
            {bucketPolicyFailedElement}
            {extensionLooksWrongElement}
            {fileTypeNotSupportedElement}
            <p className="text-muted m-xs-t-sm">Letters, numbers, underscores, and hyphens allowed. Must end with "jpg", "png", or "svg". Max size {maximumSizeInMB}MB.</p>
          </div>
        </div>
      </ResourcesMatching>
    );
  },
};



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/mixins/ImageFormMixin.js